// Initialize with something like: var matchWindowHeight = new MatchWindowHeight();
// You can trigger a resize using the above variable by doing: matchWindowHeight.resize(elem, height);

// Example: <div class="hero" match-window-height="-100|-300"></div>

// Attribute descriptions:
// match-window-height (Element will match the window height. Values passed here will add or subtract from that height.) Example values: -100, 100, -50%, -100|-200
// match-only-once (Only resize once, instead of every time the window is resized)

// When match-window-height values are separated by a | the first value is for desktop, and the second is for mobile. Percentage values are % of total viewport height.

// Broadcasts match-window-height event for jquery event listeners.

// Options Object
// matchWindowHeightAttribute: Attribute with the offset to use
// matchWindowHeightSelector: Selector to use when finding elements to match window height.

function MatchWindowHeight(opts) {
	var windowHeight = $(window).height();

	var defaults = {
		matchWindowHeightAttribute: 'match-window-height',
		matchWindowHeightSelector: '[match-window-height]'
	}

	if (!opts) opts = {};
	opts = $.extend(defaults, opts);

	matchedElements = $(opts.matchWindowHeightSelector);

	var getOffset = function(offset) {
		if (_.includes(offset, '%')) {
			return (parseInt(offset)/100) * windowHeight;
		} else {
			return parseInt(offset);
		}
	}

	var matchHeight = function(element, offset) {
		offset = element.attr(opts.matchWindowHeightAttribute) || offset;
		var mobileOffset = null;
		if (offset) {
			offset = offset.split('|');
			mobileOffset = parseInt(offset[1]);
			if (typeof mobileOffset === typeof NaN) {
				mobileOffset = false;
			} else {
				mobileOffset = getOffset(offset[1]) || 0;
			}
			offset = getOffset(offset[0]) || 0;
		}

		if (window.is_mobile && mobileOffset !== false) {
			offset = mobileOffset;
		}

		var height = windowHeight + offset;
		element.css('height', height);

		// Broadcast that this has run, so we can have code run after it is sized
		element.triggerHandler('match-window-height');
	}

	$(window).on('resize', function() {
		windowHeight = $(window).height();
		matchedElements.each(function(index, element) {
			if (!element) return;

			matchedElement = $(element);
			matchHeight(matchedElement);
			onlyOnce = matchedElement.attr('match-only-once');
			if (!_.isUndefined(onlyOnce)) {
				matchedElements.splice(index, 1, null)
			}
		});
	}).trigger('resize');

	// API

	// Manually trigger a resize.
	this.match = function(elem, offset) {
		windowHeight = $(window).height();
		matchHeight(elem, offset);
	}
	return this;
}